"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormInputExtended", {
    enumerable: true,
    get: function() {
        return FormInputExtended;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _adminicons = require("../../../admin-icons");
const _Theme = require("../../../contexts/Theme");
const _ProgressCircle = require("../../ProgressCircle/ProgressCircle");
const _FormInputGroup = /*#__PURE__*/ _interop_require_wildcard(require("../FormInputGroup"));
const _FormInput = require("../FormInput/FormInput");
const _useAsRef = require("../../../util/useAsRef");
const _useForwardedRef = require("../../../util/useForwardedRef");
const _setControlledInputValue = require("../../../util/setControlledInputValue");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormInputExtended = /*#__PURE__*/ (0, _react.forwardRef)((param, forwardedRef)=>{
    let { loading, clearable = false, icon: Icon, outerRef, onClear: onClearInput, ...props } = param;
    const { colors } = (0, _Theme.useTheme)();
    const ref = (0, _useForwardedRef.useForwardedRef)(forwardedRef);
    const onClearRef = (0, _useAsRef.useAsRef)(onClearInput);
    var _props_value;
    const [localValue, setLocalValue] = (0, _react.useState)((_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : "");
    const onClear = (0, _react.useCallback)(()=>{
        if (ref.current != null) {
            var _onClearRef_current;
            (0, _setControlledInputValue.setControlledInputValue)(ref.current, "");
            (_onClearRef_current = onClearRef.current) === null || _onClearRef_current === void 0 ? void 0 : _onClearRef_current.call(onClearRef);
        }
    }, [
        ref,
        onClearRef
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Group, {
        ref: outerRef,
        rounded: props.rounded
    }, Icon == null && (loading === false || loading == null) ? null : /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Prefix, null, loading === true ? /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
        size: 15,
        style: {
            color: colors.muted1
        }
    }) : Icon == null ? null : /*#__PURE__*/ _react.default.createElement(Icon, {
        color: colors.muted1,
        size: 15
    })), /*#__PURE__*/ _react.default.createElement(_FormInput.FormInput, {
        ...props,
        onKeyDown: (e)=>{
            if (props.undeletablePrefix != null && localValue.length === 1 && (e.key === "Delete" || e.key === "Backspace")) {
                e.preventDefault();
            }
        },
        onChange: (e)=>{
            if (props.undeletablePrefix == null || e.target.value.startsWith(props.undeletablePrefix)) {
                var _props_onChange;
                setLocalValue(e.target.value);
                (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, e);
            }
        },
        ref: ref
    }), !clearable || localValue === "" ? null : /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Suffix, null, /*#__PURE__*/ _react.default.createElement(_adminicons.RiCloseCircleLine, {
        className: "clear-button",
        tabIndex: 0,
        style: {
            display: props.value === "" ? "none" : "block",
            cursor: "pointer"
        },
        onClick: onClear,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === "Space") {
                onClear();
            }
        },
        color: colors.muted1,
        size: 15
    }))));
});
FormInputExtended.displayName = "FormInputExtended";

//# sourceMappingURL=FormInputExtended.js.map